export default "__VITE_ASSET__747c8990__"